const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // excludes I/O/0/1 — avoids visual ambiguity

export function generateGameCode(): string {
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)];
  }
  return code;
}

// Supports /join/CODE (share URL) and the legacy ?join=CODE query param.
// Cleans the URL via replaceState so a refresh doesn't re-trigger.
export function parsePendingJoinCode(): string | null {
  const pathMatch = window.location.pathname.match(/^\/join\/([A-Z0-9]{1,6})$/i);
  const params = new URLSearchParams(window.location.search);
  const rawCode = (pathMatch && pathMatch[1]) || params.get('join') || '';
  const joinCode = rawCode.toUpperCase().slice(0, 6);

  if (!joinCode || !/^[A-Z0-9]{6}$/.test(joinCode)) return null;

  window.history.replaceState({}, '', '/');
  return joinCode;
}
